// extracted by mini-css-extract-plugin
export default {"profile_div":"Edit_profile_div__V0CUF"};